// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendor" + "." + "25171d768ca71073ad09" + ".css";
};